import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.submitVerification',
    defaultMessage: 'Submit Verification',
    id: 'MUB+sG',
  },
});

export const ScanToSubmitVerificationHotkey = ({ children, onSubmitVerification }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['v'],
      doNotTrack: true,
      handler: onSubmitVerification,
      hotkey: ['v'],
      legacyCategory: 'general',
      name: intl.formatMessage(messages.name),
    }),
    [intl, onSubmitVerification],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

ScanToSubmitVerificationHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmitVerification: PropTypes.func.isRequired,
};

export default ScanToSubmitVerificationHotkey;
